import { Link } from '@mui/material';

interface CustomLinkProps {
  href: string;
  height: string;
  children: React.ReactNode;
}

const CustomLink: React.FC<CustomLinkProps> = ({ href, height, children }: CustomLinkProps) => {
  return (
    <Link
      href={href}
      underline='hover'
      sx={{
        display: 'flex',
        alignItems: 'center',
        minWidth: 0,
        height,
        color: 'typography.light',
        overflowWrap: 'anywhere',
        transition: 'color 0.15s ease',
        '&:hover': {
          color: 'secondary.main',
        },
      }}
    >
      {children}
    </Link>
  );
};

export default CustomLink;
